import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { InterviewFeedback } from '@app/model/interviewFeedback';
import { FeedbackSerializer } from '@app/model/serializer/feedback-serializer';

@Injectable({ providedIn: 'root' })
export class FeedbackService extends ApiService<InterviewFeedback> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'interview/step-feedback',
      new FeedbackSerializer());
  }
}
